/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { unitSchema } from "../unitSchema.ts";
import { z } from "zod";

export const deleteApiJingleCollectionsIdPathParamsSchema = z.object({
    "Id": z.string().uuid().describe("Идентификатор подборки")
    })

/**
 * @description Подборка удалена
 */
export const deleteApiJingleCollectionsId200Schema = z.lazy(() => unitSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const deleteApiJingleCollectionsId400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const deleteApiJingleCollectionsId401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const deleteApiJingleCollectionsId403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Подборка не найдена
 */
export const deleteApiJingleCollectionsId404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const deleteApiJingleCollectionsId500Schema = z.lazy(() => badResponseModelSchema)

export const deleteApiJingleCollectionsIdMutationResponseSchema = z.lazy(() => deleteApiJingleCollectionsId200Schema)